module.exports = __webpack_public_path__ + "img/15days-gris.0be253df.png";